import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../layouts/UserLayout'
import { Box, Card, CardContent, CircularProgress, Divider, Typography } from '@mui/material'
import { transformDetailWithPhone } from '../utils/transformDetail'
import { useNavigate, useParams } from 'react-router-dom'
import { DOMAIN } from '../utils/api'
import { handleError } from '../utils/error'
import axios from 'axios'
import { getFromStorage } from '../utils/storage'
import { currentUserActions } from '../redux/store'
import { useDispatch } from 'react-redux'
import EditIcon from '@mui/icons-material/Edit'
import { mainGreen } from '../utils/color'

export default function SearchDetail() {
	const dispatch = useDispatch()
	const { orderId } = useParams()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [searchDetail, setSearchDetail] = useState()
	const [loadingDetail, setLoadingDetail] = useState(true)

	const getSearchDetail = useCallback(
		async function () {
			setLoadingDetail(true)
			const url = `${DOMAIN}/user/search/detail/${orderId}`
			try {
				const response = await axios({
					url,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setSearchDetail(response.data)
				setLoadingDetail(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, orderId, dispatch],
	)

	useEffect(() => {
		getSearchDetail()
	}, [getSearchDetail])

	return (
		<UserLayout>
			{loadingDetail ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
					<Card
						sx={{
							padding: '20px 20px 10px 20px',
							background: '#fff',
						}}>
						<Typography
							sx={{
								display: 'inline-block',
								padding: '5px 10px',
								background: mainGreen,
								color: '#fff',
								borderRadius: '10px',
							}}>
							{searchDetail?.orderDetail.status === 'create' && 'Chờ xử lý'}
							{searchDetail?.orderDetail.status === 'produce' &&
								!searchDetail?.orderDetail.producer.produceEnd &&
								'Đang xử lý'}
							{searchDetail?.orderDetail.status === 'produce' &&
								searchDetail?.orderDetail.producer.produceEnd &&
								'Đã xử lý'}
							{searchDetail?.orderDetail.status === 'ship' &&
								!searchDetail?.orderDetail.shipper.produceEnd &&
								'Đang giao'}
							{searchDetail?.orderDetail.status === 'success' && 'Giao thành công'}
						</Typography>

						<CardContent sx={{ pl: 0, pr: 0 }}>
							<Typography>
								<b>Ca: </b>
								{searchDetail?.orderDetail.shiftCode}
								{searchDetail?.orderDetail.shiftIndex} - {searchDetail?.orderDetail.shiftDay}
							</Typography>
							<Typography>
								<b>Cửa hàng: </b>
								{searchDetail?.orderDetail.store?.name}
							</Typography>
							<Typography>
								<b>Khối lượng: </b>
								{searchDetail?.orderDetail.quantity}kg
							</Typography>
							<Typography>
								<b>Tiền: </b>
								{searchDetail?.orderDetail.totalPrice?.toLocaleString()}đ{' '}
								{searchDetail?.orderDetail.payment === 'transfer' && <b>(Chuyển khoản)</b>}
							</Typography>
							<Typography>
								<b>Thông tin: </b>
								{searchDetail?.orderDetail.detail && (
									<span
										dangerouslySetInnerHTML={{
											__html: transformDetailWithPhone(searchDetail?.orderDetail.detail),
										}}></span>
								)}
							</Typography>
							{searchDetail?.orderDetail.tag?.map((tag, index) => {
								return (
									<Typography
										sx={{
											display: 'inline-block',
											fontSize: '12px',
											padding: '2px 10px',
											borderRadius: '10px',
											color: '#fff',
											background: `${tag.color}`,
											mr: 1,
										}}
										key={index}>
										{tag.name}
									</Typography>
								)
							})}
							<Divider sx={{ mb: 1, mt: 1 }} />
							<Typography>
								<b>Người tạo: </b>
								{searchDetail?.orderDetail.creator?.user?.name}
							</Typography>
							<Typography>
								<b>Thời gian tạo: </b>
								{searchDetail?.orderDetail.creator?.createdAt}
							</Typography>
							<Divider sx={{ mb: 1, mt: 1 }} />
							<Typography>
								<b>Người xử lý: </b>
								{searchDetail?.orderDetail.producer?.user?.name || 'chưa có'}
							</Typography>
							<Typography>
								<b>Nhận xử lý: </b>
								{searchDetail?.orderDetail.producer?.produceStart || 'chưa có'}
							</Typography>
							<Typography>
								<b>Hoàn thành xử lý: </b>
								{searchDetail?.orderDetail.producer?.produceEnd || 'chưa có'}
							</Typography>
							<Divider sx={{ mb: 1, mt: 1 }} />

							<Typography>
								<b>Người giao hàng: </b>
								{searchDetail?.orderDetail.shipper?.user?.name || 'chưa có'}
							</Typography>
							<Typography>
								<b>Nhận giao hàng: </b>
								{searchDetail?.orderDetail.shipper?.shipStart || 'chưa có'}
							</Typography>
							{searchDetail?.orderDetail.confirmShip && (
								<Typography>
									<b>Người xác nhận giao hàng: </b>
									{searchDetail?.orderDetail.confirmShip?.user?.name}
								</Typography>
							)}
							<Typography>
								<b>Hoàn thành giao hàng: </b>
								{searchDetail?.orderDetail.shipper?.shipEnd || 'chưa có'}
							</Typography>
						</CardContent>
					</Card>
					{searchDetail.updatedOrderDetail.map((order, index) => {
						return (
							<Card
								key={index}
								sx={{
									padding: '10px 20px',
									background: '#fff',
									mt: 1,
								}}>
								{index === 0 && (
									<Typography
										sx={{
											display: 'inline-flex',
											alignItems: 'flex-start',
											color: '#fff',
											background: mainGreen,
											padding: '2px 10px',
											borderRadius: '10px',
											mb: 1,
										}}>
										<EditIcon sx={{ fontSize: '20px', marginRight: '5px' }} /> Nhập đơn
									</Typography>
								)}
								{index > 0 && (
									<Typography
										sx={{
											display: 'inline-flex',
											alignItems: 'flex-start',
											color: '#fff',
											background: mainGreen,
											padding: '2px 10px',
											borderRadius: '10px',
											mb: 1,
										}}>
										<EditIcon sx={{ fontSize: '20px', marginRight: '5px' }} /> Chỉnh sửa lần {index}
									</Typography>
								)}

								{index > 0 && (
									<>
										<Typography>
											<b>Người chỉnh sửa: </b>
											{order.editor.name}
										</Typography>
										<Typography>
											<b>Thời gian chỉnh sửa: </b>
											{order.timeStamp}
										</Typography>
										<Divider sx={{ mb: 1, mt: 1 }} />
									</>
								)}

								<Typography>
									<b>Khối lượng: </b>
									{order.orderData.quantity}kg
								</Typography>
								<Typography>
									<b>Tiền: </b>
									{order.orderData.totalPrice?.toLocaleString()}đ{' '}
									{order.orderData.payment === 'transfer' && (
										<span style={{ color: mainGreen }}>
											<b>(Chuyển khoản)</b>
										</span>
									)}
								</Typography>
								<Typography>
									<b>Thông tin: </b>
									{order.orderData.detail && (
										<span
											dangerouslySetInnerHTML={{
												__html: transformDetailWithPhone(order.orderData.detail),
											}}></span>
									)}
								</Typography>
								{order.orderData.tag?.map((tag, index) => {
									return (
										<Typography
											sx={{
												display: 'inline-block',
												fontSize: '12px',
												padding: '2px 10px',
												borderRadius: '10px',
												color: '#fff',
												background: `${tag.color}`,
												mr: 1,
											}}
											key={index}>
											{tag.name}
										</Typography>
									)
								})}
							</Card>
						)
					})}
				</Box>
			)}
		</UserLayout>
	)
}
